(function (root, factory) {
  var api = factory();

  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.MysteryPackCore = api;
  }
})(typeof window !== "undefined" ? window : globalThis, function () {
  "use strict";

  function normalizeSize(value) {
    return String(value || "")
      .trim()
      .toUpperCase()
      .replace(/['']/g, "")
      .replace(/\s+/g, "");
  }

  function normalizeColor(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }

  function normalizeFillRule(value) {
    var key = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_");

    if (key === "any_in_stock") return "any_in_stock";
    if (
      key === "most_units" ||
      key === "max_inventory" ||
      key === "highest_inventory"
    ) {
      return "most_units";
    }

    return "broken_colorways";
  }

  function variantEntryId(entry) {
    if (entry && typeof entry === "object") return entry.id;
    return entry;
  }

  function variantEntryQty(entry) {
    if (entry && typeof entry === "object") {
      var qty = Number(entry.qty);
      return Number.isFinite(qty) ? qty : 0;
    }
    return 0;
  }

  function parsePackCount(value) {
    var match = String(value || "").match(/\d+/);
    if (!match) return 0;

    var count = Number(match[0]);
    return Number.isInteger(count) && count > 0 ? count : 0;
  }

  function normalizeColorPriority(list) {
    if (!Array.isArray(list)) return [];

    var seen = new Set();
    var ordered = [];

    list.forEach(function (item) {
      var key = normalizeColor(item);
      if (!key || seen.has(key)) return;
      seen.add(key);
      ordered.push(key);
    });

    return ordered;
  }

  function isInStock(qty) {
    var count = Number(qty);
    return Number.isFinite(count) && count > 0;
  }

  function isBrokenColorway(variants) {
    if (!Array.isArray(variants) || !variants.length) return false;

    var hasPositive = false;
    var hasZeroOrLess = false;

    for (var index = 0; index < variants.length; index += 1) {
      var count = Number(variants[index].inventory_quantity);
      if (!Number.isFinite(count)) continue;

      if (count > 0) hasPositive = true;
      else hasZeroOrLess = true;

      if (hasPositive && hasZeroOrLess) return true;
    }

    return false;
  }

  function getEligibleColors(product, fillRule, colorPriority) {
    var byColor = {};

    (product.variants || []).forEach(function (variant) {
      var colorKey = normalizeColor(variant.color);
      if (!byColor[colorKey]) byColor[colorKey] = [];
      byColor[colorKey].push(variant);
    });

    var rule = normalizeFillRule(fillRule);
    if (rule === "any_in_stock" || rule === "most_units") {
      return new Set(
        Object.keys(byColor).filter(function (colorKey) {
          return byColor[colorKey].some(function (variant) {
            return isInStock(variant.inventory_quantity);
          });
        }),
      );
    }

    var priority = normalizeColorPriority(colorPriority);
    var brokenColors = new Set();

    Object.keys(byColor).forEach(function (colorKey) {
      if (priority.length && priority.indexOf(colorKey) === -1) return;
      if (isBrokenColorway(byColor[colorKey])) brokenColors.add(colorKey);
    });

    return brokenColors;
  }

  function buildAvailability(pool, sizeValues, fillRule, colorPriority) {
    var availability = {};

    (sizeValues || []).forEach(function (sizeValue) {
      availability[normalizeSize(sizeValue)] = { count: 0, candidates: [] };
    });

    (pool || []).forEach(function (product) {
      if (!product || !Array.isArray(product.variants)) return;

      var eligibleColors = getEligibleColors(
        product,
        fillRule,
        colorPriority,
      );
      if (!eligibleColors.size) return;

      var bySizeColor = {};

      product.variants.forEach(function (variant) {
        var sizeKey = normalizeSize(variant.size);
        if (!sizeKey || !availability[sizeKey]) return;
        if (!isInStock(variant.inventory_quantity)) return;

        var colorKey = normalizeColor(variant.color);
        if (!eligibleColors.has(colorKey)) return;

        if (!bySizeColor[sizeKey]) bySizeColor[sizeKey] = {};
        if (!bySizeColor[sizeKey][colorKey]) {
          bySizeColor[sizeKey][colorKey] = [];
        }
        bySizeColor[sizeKey][colorKey].push({
          id: variant.id,
          qty: Number(variant.inventory_quantity) || 0,
        });
      });

      Object.keys(bySizeColor).forEach(function (sizeKey) {
        availability[sizeKey].candidates.push({
          productId: product.id,
          byColor: bySizeColor[sizeKey],
        });
        availability[sizeKey].count += 1;
      });
    });

    return availability;
  }

  function shuffle(list, randomFn) {
    var random = typeof randomFn === "function" ? randomFn : Math.random;
    var copy = (list || []).slice();

    for (var index = copy.length - 1; index > 0; index -= 1) {
      var swapIndex = Math.floor(random() * (index + 1));
      var current = copy[index];
      copy[index] = copy[swapIndex];
      copy[swapIndex] = current;
    }

    return copy;
  }

  function getColorOrder(candidates, fillRule, colorPriority, randomFn) {
    var availableColors = Array.from(
      new Set(
        (candidates || []).flatMap(function (candidate) {
          return Object.keys(candidate.byColor || {});
        }),
      ),
    );
    var priority = normalizeColorPriority(colorPriority).filter(function (color) {
      return availableColors.indexOf(color) !== -1;
    });

    if (normalizeFillRule(fillRule) === "broken_colorways" && priority.length) {
      return priority;
    }

    var remaining = availableColors.filter(function (color) {
      return priority.indexOf(color) === -1;
    });

    return priority.concat(shuffle(remaining, randomFn));
  }

  function pickMostUnitsIds(candidates, count) {
    var bestByProduct = {};

    (candidates || []).forEach(function (candidate) {
      Object.keys(candidate.byColor || {}).forEach(function (colorKey) {
        (candidate.byColor[colorKey] || []).forEach(function (entry) {
          var id = variantEntryId(entry);
          var qty = variantEntryQty(entry);
          if (id == null || qty <= 0) return;

          var current = bestByProduct[candidate.productId];
          if (!current || qty > current.qty) {
            bestByProduct[candidate.productId] = { id: id, qty: qty };
          }
        });
      });
    });

    var ranked = Object.keys(bestByProduct)
      .map(function (productId) {
        return bestByProduct[productId];
      })
      .sort(function (left, right) {
        return right.qty - left.qty;
      });

    if (ranked.length < count) return [];

    return ranked.slice(0, count).map(function (entry) {
      return entry.id;
    });
  }

  function pickFulfillmentIds(
    availabilityInfo,
    requiredCount,
    fillRule,
    colorPriority,
    randomFn,
  ) {
    var count = Number(requiredCount);
    var candidates =
      availabilityInfo && Array.isArray(availabilityInfo.candidates)
        ? availabilityInfo.candidates
        : [];

    if (!Number.isInteger(count) || count <= 0 || candidates.length < count) {
      return [];
    }

    if (normalizeFillRule(fillRule) === "most_units") {
      return pickMostUnitsIds(candidates, count);
    }

    var picked = [];
    var usedProducts = new Set();
    var colorOrder = getColorOrder(
      candidates,
      fillRule,
      colorPriority,
      randomFn,
    );

    for (
      var colorIndex = 0;
      colorIndex < colorOrder.length && picked.length < count;
      colorIndex += 1
    ) {
      var colorKey = colorOrder[colorIndex];
      var products = shuffle(candidates, randomFn);

      for (
        var productIndex = 0;
        productIndex < products.length && picked.length < count;
        productIndex += 1
      ) {
        var candidate = products[productIndex];
        if (usedProducts.has(candidate.productId)) continue;

        var variantEntries = candidate.byColor && candidate.byColor[colorKey];
        if (!variantEntries || !variantEntries.length) continue;

        var shuffledEntries = shuffle(variantEntries, randomFn);
        if (!shuffledEntries.length) continue;

        var variantId = variantEntryId(shuffledEntries[0]);
        if (variantId == null) continue;

        picked.push(variantId);
        usedProducts.add(candidate.productId);
      }
    }

    return picked.length === count ? picked : [];
  }

  function findPackVariant(variants, sizeValue, packCount) {
    var sizeKey = normalizeSize(sizeValue);
    var count = Number(packCount);

    return (
      (variants || []).find(function (variant) {
        return (
          normalizeSize(variant.size) === sizeKey &&
          parsePackCount(variant.pack_size) === count
        );
      }) || null
    );
  }

  return {
    normalizeSize: normalizeSize,
    normalizeColor: normalizeColor,
    normalizeFillRule: normalizeFillRule,
    parsePackCount: parsePackCount,
    normalizeColorPriority: normalizeColorPriority,
    isInStock: isInStock,
    isBrokenColorway: isBrokenColorway,
    getEligibleColors: getEligibleColors,
    buildAvailability: buildAvailability,
    pickFulfillmentIds: pickFulfillmentIds,
    findPackVariant: findPackVariant,
  };
});
